import React, { useState, useEffect, useRef } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import SSPCommonModal from "../../CommonComponents/SSPCommonModal/SSPCommonModal";
import { Button, Divider, Grid, Box, Card, CardHeader, CardContent, Link, CircularProgress, } from '@mui/material';
import "react-datepicker/dist/react-datepicker.css";
import { post } from "../../services";
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import { SSPCommonButton } from "../../CommonComponents";
import axios from "axios";
import { boxSX, employePaymentscolumns, styles } from './Styles'
import { HSBC_EMPLOYEE_PAYMENTS_URL, hsbcBody } from "./hsbcApi";

const EmployeePayments = ({ }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [modalOpener, setmodalOpener] = useState(false);
    const [message, setmessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [row, setRows] = useState([]);
    const fileInputRef = useRef(null);
    const [erropenModal, seterrOpenModal] = useState(false);
    const [isSaveClicked, setIsSaveClicked] = useState(false);

    useEffect(() => {
        rowFetch();
    }, []);

    const rowFetch = async () => {
        setLoading(true)
        let response = await post(
            HSBC_EMPLOYEE_PAYMENTS_URL,
            hsbcBody("/process_logs", {
                "module_name": "ssp_employee_payments"
            }),
            true,
            false
        );
        if (response?.status === "success") {
            const rowsData = response?.body?.data?.map((row, index) => ({
                ...row,
                id: index + 1,
            }));
            setRows(rowsData);
            setLoading(false);

        } else if (response?.status === "error") {
            if (response?.body?.message === "Invalid Request") {
                seterrOpenModal(true);
                setLoading(false);

            } else {
                setmessage(response?.body?.message);
                setmodalOpener(true);
                setLoading(false);

            }
            setLoading(false);

        }

    };

    const downloadProcessLog = async (logId) => {
        setLoading(true)

        let response = await post(
            HSBC_EMPLOYEE_PAYMENTS_URL,
            hsbcBody("/download_process_logs", {
                "type": "PROCESS_LOG",
                log_id: logId,
            }),
            true,
            false
        );
        if (response?.status === "success") {
            setLoading(false)
            window.open(response?.body?.data);

        } else {
            setLoading(false)
            setmessage(response?.body?.message);
            setmodalOpener(true);
        }
    }

    const handleSaveData = async () => {
        if (selectedFile) {

            if (selectedFile instanceof File) {
                const fileExtension = selectedFile.name.split('.').pop().toLowerCase();
                if (fileExtension !== "xlsx") {
                    setmessage("Only .xlsx files are allowed.");
                    setmodalOpener(true);
                    return;
                }
            }
            setIsSaveClicked(true)
            let filenameWithTimestamp;
            if (selectedFile instanceof File) {
                const timestamp = new Date()
                    .toISOString()
                    .replace(/[-:.]/g, "")
                    .slice(0, 15);
                filenameWithTimestamp = `${selectedFile?.name
                    .split(".")
                    .slice(0, -1)
                    .join(".")}_${timestamp}.${selectedFile?.name?.split(".")?.pop()}`;
            } else {
                filenameWithTimestamp = selectedFile;
            }
            setLoading(true)
            let presignedUrlResponse = await post(
                HSBC_EMPLOYEE_PAYMENTS_URL,
                hsbcBody("/create_presigned_post", {
                    filename: filenameWithTimestamp,
                }),
                true,
                false
            );
            if (presignedUrlResponse?.status === 'error') {
                setIsSaveClicked(false)
                setmessage(presignedUrlResponse?.body?.message);
                setmodalOpener(true);
                return
            }
            const presignedUrl = presignedUrlResponse.body;
            if (!presignedUrl) {
                setIsSaveClicked(false)
                return;
            }

            if (selectedFile instanceof File) {
                const fileUploaded = await uploadFileWithPresignedUrl(
                    selectedFile,
                    presignedUrl
                );
                if (fileUploaded) {
                    let response = await post(
                        HSBC_EMPLOYEE_PAYMENTS_URL,
                        hsbcBody("/upload_payments", {
                            filename: presignedUrl?.fields?.key
                        }),
                        true,
                        false
                    );
                    setLoading(false)
                    if (response?.status === "success") {
                        setIsSaveClicked(false)
                        setLoading(false)
                        setmessage("File Uploaded");
                        setmodalOpener(true);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setSelectedFile(null);
                        setTimeout(() => {
                            rowFetch()
                        }, 2000);

                    } else if (response?.status === "error") {
                        setIsSaveClicked(false)
                        setLoading(false)

                        setmessage(response?.body?.message || response?.message);
                        setmodalOpener(true);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setSelectedFile(null);
                        setTimeout(() => {
                            rowFetch()
                        }, 2000);
                    }

                    else {
                        setLoading(false)
                        setIsSaveClicked(false)
                        setmessage(response?.body?.message);
                        setmodalOpener(true);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setSelectedFile(null);

                    }

                }
                if (!fileUploaded) {
                    setIsSaveClicked(false)
                    setLoading(false)
                    return;
                }
            }

        } else {
            setmessage("Please select file to upload");
            setmodalOpener(true);
            setLoading(false)
        }
    }


    const uploadFileWithPresignedUrl = async (filetoUpload, generatedUrl) => {
        try {
            const fileUploadData = new FormData();
            Object.keys(generatedUrl.fields).forEach((key) => {
                fileUploadData.append(key, generatedUrl.fields[key]);
            });
            fileUploadData.append("file", filetoUpload);
            const fileUploaded = await uploadFile(generatedUrl.url, fileUploadData);
            if (fileUploaded) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            throw error;
        }
    };

    const uploadFile = async (url, formData) => {
        try {
            const response = await axios.post(url, formData);

            if (response.status === 204) {
                return true;
            }

            if (response.status >= 200 && response.status < 300) {
                return true;
            } else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        } catch (error) {
            throw error;
        }
    };

    const handleDownloadFile = async () => {
        setLoading(true)
        let response = await post(
            HSBC_EMPLOYEE_PAYMENTS_URL,
            hsbcBody("/generate_sample_file", {
                "file_name": "sample_files/employee_payment_sample.xlsx"
            }),
            true,
            false
        );
        if (response?.status === "success") {
            window.open(response?.body?.url);
            setLoading(false)

        } else {
            setmessage(response?.body?.message || response?.message);
            setmodalOpener(true);
            setLoading(false)

        }
    }

    return (
        <div className="w-full h-full bg-[#ffffff] justify-center item-center ">
            <Card sx={{ ...styles.card, marginTop: 3 }} >
                <CardHeader
                    p={2}
                    sx={styles.cardHeader}
                    title={" Uploads Payment details"}
                    titleTypographyProps={{
                        sx: {
                            fontSize: "16px",
                            fontWeight: "600",
                            lineHeight: "16px",
                            color: "#0160F1",
                        },
                    }}
                />
                <Divider />
                <CardContent sx={styles.cardContent} >
                    <Box sx={styles.fullWidth}>
                        <Grid container rowSpacing={1} sx={{ alignItems: 'center' }}>
                            <Grid item xs={8} md={4} sm={6} sx={styles.whiteBackgrnd}>
                                <Box
                                    p={2}
                                    sx={{
                                        display: { lg: "flex", md: "flex" },
                                        gap: "1rem",
                                    }}
                                >
                                    <Box
                                        p={1}
                                        sx={styles.borderRadiusfive}
                                    >
                                        <input
                                            type="file"
                                            multiple={false}
                                            ref={fileInputRef}
                                            onChange={(e) => {
                                                const file = e?.target?.files[0];
                                                setSelectedFile(file);
                                            }}
                                        />
                                    </Box>
                                </Box>

                            </Grid>
                            <Grid item xs={4} sx={styles.whiteBackgrnd} >
                                <Box sx={styles.saveDataButton} >
                                    {!isSaveClicked &&
                                        <SSPCommonButton
                                            btnText={"SAVE DATA"}
                                            btnFunction={handleSaveData}
                                        />

                                    }
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} sx={styles.downloadSupplyerBttn}>
                            <Link
                                component={"button"}
                                color={"#0160F1"}
                                sx={boxSX}
                                onClick={handleDownloadFile}
                            >
                                {"Download Sample File"}
                            </Link>

                        </Grid>
                    </Box>
                </CardContent>
            </Card>
            <Card sx={styles.paymentReqDetailsCard} >
                <CardHeader
                    p={2}
                    sx={styles.cardHeader}
                    title={" Previous Uploads"}
                    titleTypographyProps={{
                        sx: { fontSize: "16px", fontWeight: "600", lineHeight: "16px", color: "#0160F1", },
                    }}
                    action={
                        <>
                            <Button onClick={() => window.location.reload()}>
                                Refresh Page
                            </Button>
                        </>
                    }
                />
                <Divider />
                <ErrorModal openModal={erropenModal} />
                {loading && (
                    <div style={styles.loaderOverlay}>
                        <CircularProgress />
                    </div>
                )}

                <CardContent sx={styles.cardContent}>
                    <Box sx={styles.tableContainer}>
                        <DataGrid

                            rowHeight={80}
                            showCellRightBorder={true}
                            sx={{
                                ".MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: "bold !important",
                                },
                                overflowX: "scroll",
                            }}
                            rows={row}
                            columns={employePaymentscolumns(downloadProcessLog)}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 10,
                                    },
                                },
                            }}
                            checkboxSelection={false}
                            headerClassName="header-center"
                            rowsPerPageOptions={[10]}
                            pageSize={10}
                            getRowId={(row) => row.id}
                            components={{
                                Toolbar: GridToolbar,
                            }}
                            componentsProps={{
                                Toolbar: {
                                    showQuickFilter: true,
                                    quickFilterProps: { debounceMs: 500 },
                                },
                            }}
                        />

                    </Box>
                </CardContent>
                {modalOpener && (
                    <SSPCommonModal
                        open={modalOpener}
                        handleOpenClose={setmodalOpener}
                        message={message}
                    />
                )}
            </Card>

        </div>
    )
}
export default EmployeePayments